import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IzbMouDaz = ({question,answer}) => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 
  
  return (
    <>
      <Breadcrumb2
        Heading="Latest News"
        img={BackgroundBrundcrumb}
        show={true}
      
      />

        <section>
            <div className="container pt-5">
              <h1 className="pb-5 text-left">Indo Zambia Bank signs a Memorandum of Understanding (MoU) with the Dairy Association of Zambia (DAZ)</h1>
    
              <p className="pb-3">Indo Zambia Bank is pleased to announce the signing of a Memorandum of Understanding (MoU) with the Dairy Association of Zambia (DAZ) for the provision of loan facilities to its members. Through this strategic partnership, the Bank will extend financing to eligible DAZ members under the terms outlined in the MoU.</p>

              <p className="pb-3">This initiative marks a significant step in the Bank’s ongoing efforts to support Zambia’s agricultural sector by promoting financial inclusion and empowering small and medium enterprises within the dairy value chain. During the MoU signing ceremony, Managing Director, Mr. Brajesh Kumar Singh, took the opportunity to officially launch two new specialised bank products:</p>

              <p className="pb-3">“Indo Dairy Production Finance Scheme is aimed at facilitating and maintaining the increase of milk production among smallholder dairy farmers by providing short-term financing to cover essential costs such as animal feeding and veterinary care. Indo Dairy Development Finance Scheme, is aimed at supporting the expansion and development of dairy farms by providing financing for farm infrastructure, the purchase of dairy cows, and transport assets.” – Mr. Brajesh Kumar Singh</p>

              <p className="pb-3">At the event, Chief Executive Officer of the Dairy Association of Zambia, Mr. Victor Ng’andu, welcomed the partnership and emphasised the critical need for accessible financing within the dairy sector. He stated:</p>

              <p className="pb-3">"Access to finance for members of the Dairy Association of Zambia has been a challenge, as most of our members are striving to improve their productivity – and that can only be done with capital. We thank Indo Zambia Bank for coming on board and opening their doors to support our members." – Mr. Victor Ng’andu, Chief Executive Officer- Dairy Association of Zambia.</p>

              <p className="pb-3">The newly launched products are now readily available across our branch network nationwide. For enquiries, call <a href="tel:8002">8002</a>, email <a href="mailto:credit@izb.co.zm">credit@izb.co.zm</a> or visit your nearest branch.</p>

              <h2 className="pt-4 pb-4">Gallery</h2>
            
              <div className="test news-slider-list-slider row align-items-center pb-4">
                <Slider {...settings}>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-1.jpeg" alt="IZB Signs MOU with DAZ" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-2.jpeg" alt="IZB Signs MOU with DAZ" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-3.jpeg" alt="IZB Signs MOU with DAZ" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-4.jpeg" alt="IZB Signs MOU with DAZ" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-5.jpeg" alt="IZB Signs MOU with DAZ" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-6.jpeg" alt="IZB Signs MOU with DAZ" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-7.jpeg" alt="IZB Signs MOU with DAZ" />
                  </div>
                </Slider>
              </div>
            </div>

            

        </section>

      <CustomerCare />
      <OurStores />

    </>
  );
};

export default IzbMouDaz;